export default {
  items: [],
  banks: []
};
